import $ from 'jquery';
import 'slick-carousel';

$('.moments-teaser__items').each(function () {
    var $slider = $(this);

    $slider.slick({
        autoplay: false,
        infinite: true,
        arrows: true,
        dots: false,
        draggable: true,
        rows: 0,
        prevArrow: '<button title="'+ window.translationStrings.prevSlide +'" class="slick-prev fa-thin fa-arrow-left"></button>',
        nextArrow: '<button title="'+ window.translationStrings.nextSlide +'" class="slick-next fa-thin fa-arrow-right"></button>',
        appendArrows: $('<div>', {class: 'moments-teaser__arrows'}).insertAfter($slider),
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: "unslick"
            }
        ]
    });
});

